<template>
  <div class="subpage__cnt col-xl-10 offset-xl-1 text-center">
    <ListPageHeaderNoLine2 :page-info="pageInfo">
    </ListPageHeaderNoLine2>
          <div class="subpage-list uni-search-wrp">
      <Hero :filter-dorm="false"/>      
      </div>    
    <FeaturedDormsNoTabs />
  </div>
</template>

<script>
import ListPageHeaderNoLine2 from '@/components/ListPageHeaderNoLine2'
import FeaturedDormsNoTabs from '@/components/Home/FeaturedDormsNoTabs.vue'
import Hero from '@/components/Home/HeroSearch.vue'
import axios from 'axios'
export default {
  name: 'ErrorPage404',
  components: {
    ListPageHeaderNoLine2, FeaturedDormsNoTabs, Hero
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Page Not Found',
        link: [
         { rel: 'canonical' },
         { href: this.url }
       ]  
    }
  },
  data () {
    return {
      url: '',
      pageInfo: {
        icon: require('@/assets/img/yurt-ara.svg'),
        title: '<span class="color-light-green">Ooops!</span><br>',
        text: 'Page Not Found! Would you like to see popular movies?'
      },
      dorms: [],
      cityID: null,
      featuredCities: [],
      cities: [],
      searchUrl: {},
      errors: []
    }
  },
  methods: {
    onSelect (opt) {
      // console.log(opt)
    },
    selectDorm (opt) {
      // let selected = this.$refs.myinput.value
      let selectedDorm  = this.dorms.find(function (dorm) { return dorm.name === opt.name } )
      if(selectedDorm) {
        this.$router.push({ name: 'MovieDetail', params: { slug: selectedDorm.slug, id: opt.id } })
        window.localStorage.setItem('dormid', opt.id)
        let url = window.location.origin + '/movie-search'
        window.localStorage.setItem('url', url)
      }
    },
    getPopularCities () {
      let self = this
      axios.get('/3/movie/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1')
        .then(response => {
          self.featuredCities = response.data.results
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getDormsList () {
      let self = this
      axios.get('/site/search/dorms')
        .then(response => {
           self.dorms = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    this.getPopularCities()
    this.getDormsList()
    this.url = window.location.origin + '/movie-search'
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/city-list";
.mycenter {
 display:table;
 margin:0 auto;
}
.mycolor {
  color: #656e8d;
}
</style>
